import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const FAQS = [
  {
    q: "I've never done therapy before. Where do I even start?",
    a: "Both paths are valid. If you already feel ready to begin the work, book a full 60-minute Individual Session — we'll start with a structured intake and move forward from there. If you'd prefer to meet briefly first, the 20-minute Discovery Call (₹250) is available so you can ask questions and gauge fit. Either way, the space is confidential and there's no pressure."
  },
  {
    q: 'Is everything I share with you confidential?',
    a: 'Yes — strictly. What you share in sessions stays between us, with the only legal exception being immediate risk to self or others (a standard ethical boundary in all of psychology). Your sessions are not recorded, and no third party has access to your information.'
  },
  {
    q: "What if I'm not sure CBT is the right approach for me?",
    a: "CBT is one of the most rigorously researched therapies — especially for anxiety, OCD, and stress — but it isn't the only tool I use. I integrate psychoeducation, mindfulness-based techniques, and emotion-focused work, and I tailor the approach to you. We can discuss fit either in your first full session or in a Discovery Call beforehand, whichever you prefer."
  },
  {
    q: 'How many sessions will I need?',
    a: "Honestly, it depends. Many clients see real shifts in 4–8 sessions for focused issues. For OCD or longer-standing patterns, we often work over 3–6 months. I'll never extend therapy unnecessarily — my goal is to teach you to become your own primary healer."
  },
  {
    q: 'Can I cancel or reschedule?',
    a: 'Yes. Sessions can be rescheduled up to 3 hours before the slot. After that, the slot is held for you and is non-refundable (since it can no longer be offered to someone else).'
  },
  {
    q: 'Do you take insurance in India?',
    a: "Indian health insurance currently doesn't cover outpatient therapy in most cases. I keep my pricing as accessible as possible, and the 3-session and 5-session packages give meaningful discounts for committed work."
  },
  {
    q: 'Are sessions in-person or online?',
    a: 'All sessions are conducted online via a secure Google Meet link, which is shared in your booking confirmation email. This makes therapy accessible from anywhere in India.'
  },
  {
    q: 'What if I just need someone to vent to right now?',
    a: "A full 60-minute Individual Session gives us the time and structure to really hold what you're carrying — that's often the most supportive option when things feel heavy. If you need urgent emotional support outside of session times, please reach out to iCall (9152987821) or AASRA (9820466726). I can also connect you to crisis resources if needed."
  }
];

export const FAQSection = () => {
  return (
    <section id="faq" className="py-16 md:py-20 bg-card">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center space-y-3 mb-10">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground">
              Frequently Asked Questions
            </h2>
            <p className="text-base text-muted-foreground">
              The things most people quietly wonder before booking.
            </p>
          </div>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="bg-background border rounded-lg px-5">
                <AccordionTrigger className="text-left text-base font-medium hover:no-underline" data-testid={`faq-question-${i + 1}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-muted-foreground leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
